import { set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class HotelParityPosRoute extends Route {
  queryParams = {
    maxPersons: {
      refreshModel: true,
    },
  };

  @service access;
  @service errorTracking;
  @service('hotel-and-market') hotelAndMarketService;
  @service liveupdate;
  @service store;
  @service transition;

  activate() {
    super.activate(...arguments);
    set(this, 'liveupdate.parityPOSTabOpen', true);
  }

  beforeModel(transition) {
    if (!this.access.hasFeature('subscription.parity.pos')) {
      this.transition.redirectToTab(transition, 'hotel.parity.list');
    } else {
      this.transition.validatePOSQueryParams(transition);
    }
  }

  deactivate() {
    super.deactivate(...arguments);
    set(this, 'liveupdate.parityPOSTabOpen', false);
  }

  model(params) {
    const model = {
      periods: [],
      isLoading: true,
    };

    const today = this.hotelAndMarketService.getLocalTime();
    const dateRangeStart = today.format('YYYY-MM-DD');
    const dateRangeEnd = today.add(29, 'day').format('YYYY-MM-DD');

    const requestParityPos = {
      namespace: APIGATEWAY,
      typeKey: 'parities/pos',
      hotel_id: this.hotelAndMarketService.hotel?.id,
      from_date_range_start: dateRangeStart,
      from_date_range_end: dateRangeEnd,
      los: this.hotelAndMarketService.hotel?.defaultLosParity[0],
      persons: params.maxPersons,
      membershiptype: 0,
      meta: 'nested',
    };
    this.store
      .query('period', requestParityPos)
      .then((requestedPosParities) => {
        set(model, 'periods', [...model.periods, ...requestedPosParities]);
        set(model, 'isLoading', false);
      })
      .catch((e) => {
        set(model, 'isLoading', false);
        this.errorTracking.captureException(e);
      });

    this.liveupdate.updateSelection({
      currentHotelId: this.hotelAndMarketService.hotel?.id, // current hotel id
      maxPersons: params.maxPersons,
    });

    return model;
  }
}
